export default "__VITE_ASSET__CK8yvoJS__"